import { useEffect, useState } from "react";

import { Box, Grid, Typography } from "@material-ui/core";

import { Icon } from "../base";
import { ShaDowBox } from "../boxes";
import { COLORS } from "../../theme/colors";
import { GraphFooter } from "./graphFooter";
import NoDataIcon from "../../assets/images/icons/no-data.svg";
import NoDataPieIcon from "../../assets/images/icons/no-data-pie-chart.svg";
import NoDataAreaIcon from "../../assets/images/icons/no-data-area-chart.svg";
import NoDataLineIcon from "../../assets/images/icons/no-data-line-chart.svg";
import NoDataBubblesIcon from "../../assets/images/icons/no-data-bubbles-chart.svg";

const icon = {
  simple: {
    src: NoDataIcon,
    style: {
      marginBottom: 25,
    },
  },
  area: {
    src: NoDataAreaIcon,
    style: {
      width: "100%",
    },
  },
  line: {
    src: NoDataLineIcon,
    style: {
      marginBottom: -20,
      maxWidth: 305,
      width: "100%",
    },
  },
  pie: {
    src: NoDataPieIcon,
    style: {
      marginBottom: -20,
    },
  },
  bubbles: {
    src: NoDataBubblesIcon,
  },
};

const Card = ({ title, type, items, boxStyle, gridStyle, iconStyle }) => {
  return (
    <Box style={{ padding: 24, ...boxStyle }}>
      <Typography variant="h4">{title || ""}</Typography>
      <Grid
        container
        justifyContent="center"
        alignItems="flex-end"
        style={{
          height: 200,
          ...gridStyle,
        }}
      >
        <Icon src={icon[type].src} style={iconStyle || icon[type].style} />
      </Grid>
      <Typography
        style={{
          textAlign: "center",
          color: COLORS.darks[0][50],
          marginTop: 10,
          marginBottom: items.length ? 25 : 0,
        }}
      >
        No data available yet
      </Typography>
      {items.length > 0 ? (
        <GraphFooter
          style={{ marginTop: 0 }}
          typographyStyle={{ color: COLORS.darks[0][25] }}
          items={items}
        />
      ) : null}
    </Box>
  );
};

export const NoDataCard = ({
  title,
  type,
  footerNames = [],
  rootStyle,
  withShaDowBox = true,
  boxStyle,
  gridStyle,
  iconStyle,
}) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(
      footerNames.map((name) => ({
        name: name,
        color: COLORS.darks[0][25],
      }))
    );
  }, []);

  if (withShaDowBox) {
    return (
      <ShaDowBox fullHeight style={{ minHeight: 360, ...rootStyle }}>
        <Card
          title={title}
          type={type}
          items={items}
          boxStyle={boxStyle}
          gridStyle={gridStyle}
          iconStyle={iconStyle}
        />
      </ShaDowBox>
    );
  }

  return (
    <Card
      title={title}
      type={type}
      items={items}
      boxStyle={boxStyle}
      gridStyle={gridStyle}
      iconStyle={iconStyle}
    />
  );
};

NoDataCard.defaultProps = {
  type: "simple",
};
